import React from 'react'
import PropTypes from 'prop-types'
import TenantsSelect from './tenants-select'
import TenantUsers from './tenant-users'

class TenantPermissions extends React.Component {
  constructor (props) {
    super(props)
    this.handleTenantIdSelected = this.handleTenantIdSelected.bind(this)
  }
  handleTenantIdSelected (id) {
    const { router } = this.context
    router.push(`/admin/permissions/tenant/${id}`)
  }

  render () {
    const { params } = this.props
    const { tenantId } = params

    return (
      <div className='portlet-body'>
        <div className='row margin-top-10'>
          <TenantsSelect
            className='col-md-4'
            selectedTenantId={tenantId}
            onTenantIdSelected={this.handleTenantIdSelected}
          />
        </div>
        {tenantId ? <TenantUsers id={tenantId} /> : null}
      </div>
    )
  }
}

TenantPermissions.propTypes = {
  params: PropTypes.object.isRequired
}

TenantPermissions.contextTypes = {
  router: PropTypes.object
}

export default TenantPermissions



// WEBPACK FOOTER //
// ./src/pages/admin/permissions/tenant-permissions/index.js